
import { useContext } from "react";

import { findCharacterizationById } from "../../../../lib/helper";

import { AnswerContext } from "../../../../state/answers";

import {   
  
  Characterization,

  CharacterizationBlurb,

  CharacterizationContent,
  
  CharacterizationHeader,

  CharacterizationLink,

} from "../../../../components/characterization";

export default function Characterization() {

  const { selectedAnswers } = useContext( AnswerContext );
  
  const characterizationHistogram = {};

  const answers = selectedAnswers.map( answers => answers.answers ).flat().filter( Boolean );

  answers.forEach( answer => {

    if ( answer.characterization_id ) {

      const value = characterizationHistogram[ answer.characterization_id ] ?? 0;

      characterizationHistogram[ answer.characterization_id ] = value + ( answer.weight ?? 0 );

    }

  } );

  const topThreeCharacterizations = Object.entries( characterizationHistogram )

    .sort( ( a, b ) => a[ 1 ] < b[ 1 ] ? 1 : a[ 1 ] > b[ 1 ] ? -1 : 0 ).map( item => parseInt( item[ 0 ] ) ).slice( 0, 3 );

  const characterizations = topThreeCharacterizations.map( id => findCharacterizationById( id ) );

  return (

    <div className="flex flex-col items-center py-4 gap-4">

      <p className="sm:text-lg text-black">Based on your answers, we think you can strengthen your lab in these key areas:</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

        { characterizations.map( characterization => (

          <Characterization key={ characterization.id }>

            <CharacterizationContent>

              <CharacterizationHeader>{ characterization.characterization }</CharacterizationHeader>

              <CharacterizationBlurb>{ characterization.blurb }</CharacterizationBlurb>
              
              <CharacterizationLink>Get Help with { characterization.characterization }</CharacterizationLink>

            </CharacterizationContent>

          </Characterization>

        ) ) }

      </div>

    </div>

  )

}
